import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import MovieCard from '../components/MovieCard';
import { moviesAPI } from '../api';
import { useSettings } from '../contexts/SettingsContext';

const NowPlaying = () => {
  const { settings } = useSettings();
  const [movies, setMovies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadMovies();
  }, []);

  // Update title on mount
  useEffect(() => {
    document.title = `Vizyondaki Filmler - ${settings.site_name || 'Cinefora'}`;
  }, [settings.site_name]);

  const loadMovies = async () => {
    try {
      // Get movies with active showtimes (today or future)
      const response = await moviesAPI.getWithShowtimes();
      setMovies(response.data);
    } catch (error) {
      console.error('Error loading movies:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Helmet>
        <title>Vizyondaki Filmler - {settings.site_name || 'Cinefora'}</title>
        <meta name="description" content="Cinefora'da vizyondaki tüm filmleri keşfedin. Güncel sinema filmleri ve seans bilgileri." />
        <meta name="keywords" content="vizyon filmleri, sinema, güncel filmler, cinefora" />
      </Helmet>
      <Header />
      
      <div className="container mx-auto px-6 py-32">
        <h1 className="text-4xl font-bold text-white mb-8">Vizyondaki Filmler</h1>
        
        {loading ? (
          <p className="text-white text-center">Yükleniyor...</p>
        ) : movies.length === 0 ? (
          <p className="text-gray-400 text-center">Henüz vizyonda film bulunmamaktadır.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {movies.map((movie) => (
              <MovieCard key={movie._id} movie={movie} />
            ))}
          </div>
        )}
      </div>
      
      <Footer />
    </div>
  );
};

export default NowPlaying;
